import { useState } from "react";
import LoadableButton from "../../buttons/LoadableButton";
import { Dropdown } from "antd";
import { exportAsCSV } from "../../../services/exportAsCSV";
import { exportAsPDF } from "../../../services/exportAsPDF";
import { useResponsive } from "../../../hooks/useResponsive";
import { LuDownload } from "react-icons/lu";

export default function ExportHandler({ exportHandler }) {
  const { isMobile } = useResponsive();
  const [isExportLoading, setIsExportLoading] = useState(false);
  
  const items = [
    {
      key: "1",
      label: <button onClick={() => handleExport("csv")}>Export as CSV</button>,
    },
    // {
    //   key: "2",
    //   label: <button onClick={() => handleExport("pdf")}>Export as PDF</button>,
    // },
  ];

  const handleExport = async (type) => {
    setIsExportLoading(true);
    let { data, removableColumns, fileName } = await exportHandler();
    if (data && type == "csv") {
      exportAsCSV(data, removableColumns, fileName);
    }
    if (data && type == "pdf") {
      exportAsPDF(data, removableColumns, fileName);
    }
    setIsExportLoading(false);
  };

  return (
    <div className="w-full md:w-auto">
      <Dropdown
        menu={{ items }}
        placement="bottomLeft"
        arrow
        trigger={["click"]}
      >
        <LoadableButton
          className={`${
            isMobile ? "bg-primary-mobile py-3 w-full" : "bg-primary py-1.5"
          } text-sm text-white font-semibold px-4 rounded-lg themeHover duration-500`}
          img={<LuDownload size={16} />}
          disabled={isExportLoading}
          lable="Export"
          isLoading={isExportLoading}
          loadingLable="Exporting..."
        />
      </Dropdown>
    </div>
  );
}
